var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    content: !_vm.isContextMenuVisible ? _vm.$t('venue.seat.context.tooltip') : null,
    placement: 'top-center',
    classes: ['org-theme'],
    targetClasses: ['it-has-a-tooltip'],
    offset:0,
    delay:{ show: 500, hide: 100 },
  }),expression:"{\n    content: !isContextMenuVisible ? $t('venue.seat.context.tooltip') : null,\n    placement: 'top-center',\n    classes: ['org-theme'],\n    targetClasses: ['it-has-a-tooltip'],\n    offset:0,\n    delay:{ show: 500, hide: 100 },\n  }"}],attrs:{"height":_vm.height,"width":_vm.width,"color":_vm.color,"hover":_vm.hover,"disabled":""}},[_c('v-layout',{attrs:{"row":"","fill-height":"","justify-center":"","align-center":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{class:[
          _vm.labelFont,
          'font-weight-bold',
          'text-xs-center',
          _vm.labelFontColor ]},[_vm._v("\n        "+_vm._s(_vm.label)+"\n      ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }